import { useCookieConsent } from '@/contexts/CookieConsentContext';
import CookieBanner from './cookie-banner';

export default function GlobalCookieBanner() {
  const { showBanner } = useCookieConsent();

  if (!showBanner) {
    return null;
  }

  return <CookieBanner />;
}